<template>
  <div :class="[type]" class="tol-alert">
    <font-awesome-icon :icon="icon" />
    <div>
      {{ message }}
      <ul v-if="items.length > 0">
        <li v-for="(item, index) in items" :key="index">
          {{ item }}
        </li>
      </ul>
      <slot name="update-alert" :value="updateSummary"> </slot>
    </div>
    <font-awesome-icon v-if="dismissable" class="dismiss" icon="times" @click="$emit('dismiss')" />
  </div>
</template>

<script>
export default {
  name: 'TolAlert',
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'info',
      validator(type) {
        return [
          'info', // blue
          'success', // green
          'warning', // orange
          'error' // red
        ].includes(type);
      }
    },
    items: {
      type: Array,
      default: () => []
    },
    dismissable: {
      type: Boolean,
      default: false
    },
    updateSummary: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'info':
          return 'info-circle';
        case 'success':
          return 'check-circle';
        default:
          return 'exclamation-circle';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';
@import '../styles/variables.scss';

.tol-alert {
  margin: $alert-vertical-margin 0px;
  padding: 34px $details-padding;
  color: $white;
  font-size: 115%;
  width: 100%;
  display: flex;
  justify-content: space-around;

  &.slider {
    ul li span a {
      color: $white;
    }
  }

  > div {
    flex: 1 1 auto;
    margin: -3px 15px 0 15px;
  }

  > svg {
    flex: 0 0 auto;
  }

  &.info {
    background-color: $blue;
  }

  &.success {
    background-color: $green;
  }

  &.warning {
    background-color: $orange;
  }

  &.error {
    background-color: $red;
  }

  ul {
    margin-bottom: 0;
  }

  .dismiss {
    cursor: pointer;
  }
}
</style>
